import {createRouter, createWebHistory} from 'vue-router';

import HomeIndex from '@/views/frontend/pages/home/home-index.vue';
import Index from '@/views/frontend/pages/home/home-1/home.vue'
import IndexTwo from '@/views/frontend/pages/home/home-2/index.vue'
import IndexThree from '@/views/frontend/pages/home/home-3/index-three.vue'
import IndexFour from '@/views/frontend/pages/home/home-4/index-four.vue'
import IndexFive from '@/views/frontend/pages/home/home-5/index-five.vue'
import IndexSix from '@/views/frontend/pages/home/home-6/index-six.vue'
import IndexSeven from '@/views/frontend/pages/home/home-7/index-seven.vue'
import IndexEight from '@/views/frontend/pages/home/home-8/index-eight.vue'
import IndexNine from '@/views/frontend/pages/home/home-9/index-nine.vue'
import IndexTen from '@/views/frontend/pages/home/home-10/index-ten.vue'

import ServiceIndex from '@/views/frontend/pages/services/service-index.vue';
import Services_Grid from '@/views/frontend/pages/services/services-grid.vue'
import Services_List from '@/views/frontend/pages/services/services-list.vue'

import DetailIndex from '@/views/frontend/pages/services/details-index.vue'
import Services_Details from '@/views/frontend/pages/services/services-details/services-details.vue'
import Services_Details2 from '@/views/frontend/pages/services/services-details2/services-details2.vue'

;
import Services_Search from '@/views/frontend/pages/services/services-search.vue'

import ServiceCategories from '@/views/frontend/pages/services/categories/service-categories.vue'
import Services_Categories from '@/views/frontend/pages/services/categories/services-categories.vue'
import Services_Categories_2 from '@/views/frontend/pages/services/categories/services-categories-2.vue'

import ServiceProvider from '@/views/frontend/pages/services/providers/service-provider.vue'
import Services_Providers from '@/views/frontend/pages/services/providers/services-providers.vue'
import Provider_Details from '@/views/frontend/pages/services/providers/provider-details/provider-details.vue'
import Create_Service from '@/views/frontend/pages/services/create-service/create-service.vue'
import ServiceRequest from '@/views/frontend/pages/services/service-request.vue'

import CustomerIndex from '@/views/frontend/pages/customers/customer-index.vue'
import User_Dashboard from '@/views/frontend/pages/customers/user-dashboard.vue'
import User_Booking_List from '@/views/frontend/pages/customers/user-booking-list.vue'
import User_Booking_Calendar from '@/views/frontend/pages/customers/user-booking-calendar.vue'
import Favourites from '@/views/frontend/pages/customers/customer-favourites.vue'
import Customer_Wallet from '@/views/frontend/pages/customers/customer-wallet.vue'
import Customer_Reviews from '@/views/frontend/pages/customers/customer-reviews.vue'
import User_Chat from '@/views/frontend/pages/customers/user-chat.vue'

import CustomerSettings from '@/views/frontend/pages/customers/settings/customer-settings.vue'
import Account_Settings from '@/views/frontend/pages/customers/settings/account-settings.vue'
import Security_Settings from '@/views/frontend/pages/customers/settings/security-settings.vue'
import Login_Activity from '@/views/frontend/pages/customers/settings/login-activity.vue'
import Device_Managment from '@/views/frontend/pages/customers/settings/device-managment.vue'
import Notification_Settings from '@/views/frontend/pages/customers/settings/notification-settings.vue'
import Connected_Apps from '@/views/frontend/pages/customers/settings/connected-apps.vue'

import Pages from '@/views/frontend/pages/pages/pages.vue'
import AboutUs from '@/views/frontend/pages/pages/aboutUs/aboutus.vue'
import User_Booking from '@/views/frontend/pages/pages/booking/booking-2/user-booking.vue'
import Booking_Payment from '@/views/frontend/pages/pages/booking/booking-payment/booking-payment.vue'
import Booking_Success from '@/views/frontend/pages/pages/booking/booking-2/booking-success.vue'
import Booking_Details from '@/views/frontend/pages/pages/booking/booking-details/booking-details.vue'
import PagesBooking from '@/views/frontend/pages/pages/booking/booking/booking.vue'
import Invoice from '@/views/frontend/pages/pages/booking/invoice.vue'
import Categories from '@/views/frontend/pages/pages/categories/categories.vue'
import ComingSoon from '@/views/frontend/pages/pages/comingsoon/comingsoon.vue'
import ContactUs from '@/views/frontend/pages/pages/contactUs/contact.vue'
import Installer from '@/views/frontend/pages/pages/installer.vue';
import NotificationPage from '@/views/frontend/pages/pages/notification.vue';
import Faq from '@/views/frontend/pages/pages/faq/faq.vue'
import HowItWorks from '@/views/frontend/pages/pages/howitswork/howitswork.vue'
import Maintenance from '@/views/frontend/pages/pages/maintenance/maintenance.vue'
import Pricing from '@/views/frontend/pages/pages/pricingplan/pricing.vue'
import PrivacyPolicy from '@/views/frontend/pages/pages/privacypolicy/privacypolicy.vue'
import TermsConditions from '@/views/frontend/pages/pages/termscondition.vue'
import FrontBooking from '@/views/frontend/pages/pages/booking/booking.vue'
import SessionExpired from '@/views/frontend/pages/pages/session-expired.vue'
import Error_404 from '@/views/frontend/pages/pages/error/error-404.vue'
import Error_500 from '@/views/frontend/pages/pages/error/error-500.vue'
import Login from '@/views/frontend/pages/pages/auth/login.vue'
import Success from '@/views/frontend/pages/pages/auth/success.vue'
import ForgotPassword from '@/views/frontend/pages/pages/auth/forgot-password.vue'
import Register from '@/views/frontend/pages/pages/auth/register.vue'
import Provider_Register from '@/views/frontend/pages/pages/auth/provider-register.vue'
import Reset_Password from '@/views/frontend/pages/pages/auth/reset-password.vue'
import Otp_Phone from '@/views/frontend/pages/pages/auth/otp-phone.vue'
import Otp_Email from '@/views/frontend/pages/pages/auth/otp-email.vue'
import Free_Trail from '@/views/frontend/pages/pages/auth/free-trail.vue'

import Blogs from '@/views/frontend/pages/pages/blogs/blogs.vue';
import Blog_Grid from '@/views/frontend/pages/pages/blogs/blog-grid.vue'
import Blog_List from '@/views/frontend/pages/pages/blogs/blog-list.vue'
import Blog_Details from '@/views/frontend/pages/pages/blogs/blog-details.vue'
import Provider_Dashboard from '@/views/frontend/pages/providers/dashboard/provider-dashborad.vue'
import Provider_Services from '@/views/frontend/pages/providers/provider-services.vue'
import Provider_Service_List from '@/views/frontend/pages/providers/provider-service-list.vue'
import Provider_Booking from '@/views/frontend/pages/providers/provider-booking.vue'
import Provider_Booking_Calendar from '@/views/frontend/pages/providers/provider-booking-calendar.vue'
import Staff_List from '@/views/frontend/pages/providers/staff/staff-list.vue'
import Staff_Grid from '@/views/frontend/pages/providers/staff/staff-grid.vue'
import Staff_Details from '@/views/frontend/pages/providers/staff/staff-details.vue'
import Customer_List from '@/views/frontend/pages/providers/customer/customer-list.vue'
import Customer_Grid from '@/views/frontend/pages/providers/customer/customer-grid.vue'
import Customer_Details from '@/views/frontend/pages/providers/customer/customer-details.vue'
import Provider_Payout from '@/views/frontend/pages/providers/provider-payout.vue'
import Provider_Transaction from '@/views/frontend/pages/providers/provider-transaction.vue'
import Provider_Holiday from '@/views/frontend/pages/providers/provider-holiday.vue'
import Provider_Leave_History from '@/views/frontend/pages/providers/provider-leave-history.vue'
import Provider_Coupons from '@/views/frontend/pages/providers/provider-coupons.vue'
import Provider_Offers from '@/views/frontend/pages/providers/provider-offers.vue'
import Provider_Reviews from '@/views/frontend/pages/providers/provider-reviews.vue'
import Provider_Enquiry from '@/views/frontend/pages/providers/provider-enquiry.vue'
import Provider_Earnings from '@/views/frontend/pages/providers/provider-earnings.vue'
import Provider_Chat from '@/views/frontend/pages/providers/provider-chat.vue'
import Provider from '@/views/frontend/pages/providers/provider.vue';
import Provider_Settings from '@/views/frontend/pages/providers/settings/provider-settings.vue'
import Provider_Appointment_Settings from '@/views/frontend/pages/providers/settings/provider-appointment-settings.vue'
import Provider_Accounts_Settings from '@/views/frontend/pages/providers/settings/provider-accounts-settings.vue'
import Provider_Social_Profile from '@/views/frontend/pages/providers/settings/provider-social-profile.vue'
import Provider_Security_Settings from '@/views/frontend/pages/providers/settings/provider-security-settings.vue'
import Provider_Device_Management from '@/views/frontend/pages/providers/settings/provider-device-management.vue'
import Provider_Login_Activity from '@/views/frontend/pages/providers/settings/provider-login-activity.vue'
import Provider_Plan from '@/views/frontend/pages/providers/settings/provider-plan.vue'
import Provider_Notifcations from '@/views/frontend/pages/providers/settings/provider-notifcations.vue'
import Provider_Connected_Apps from '@/views/frontend/pages/providers/settings/provider-connected-apps.vue'
import Payment_Settings from '@/views/frontend/pages/providers/settings/payment-settings.vue'
import Verification from '@/views/frontend/pages/providers/settings/provider-verification.vue'



/**************** Admin  *************/
import abusereports from '@/views/admin/pages/Abusereport/abuse-reports.vue'
import Accountsettings from '@/views/admin/pages/settings/Generalsettings/accountsettings.vue'
import Addannouncement from '@/views/admin/pages/Support/addannouncement.vue'
import AddBlogcategories from '@/views/admin/pages/Content/Blog/addblogcategories.vue'
import AddBlog from '@/views/admin/pages/Content/Blog/addblog.vue'
import AddCategories from '@/views/admin/pages/Services/addcategories.vue'
import AddCity from '@/views/admin/pages/Content/Locations/addcities.vue'
import AddCountries from '@/views/admin/pages/Content/Locations/addcountries.vue'
import AddCustomer from '@/views/admin/pages/Usermanagement/User/addcustomer.vue'
import AddMembership from '@/views/admin/pages/Membership/addmembership.vue'
import AddPage from '@/views/admin/pages/Content/pages/addpages.vue'
import AddPayout from '@/views/admin/pages/Finance&accounts/Payouts/addpayout.vue'
import AddProvider from '@/views/admin/pages/Usermanagement/User/addprovider.vue'
import AddReviewtype from '@/views/admin/pages/Services/Review/addreviewtype.vue'
import AddRole from '@/views/admin/pages/Usermanagement/addrole.vue'
import AddService from '@/views/admin/pages/Services/Addservice/addservice.vue'
import AddState from '@/views/admin/pages/Content/Locations/addstate.vue'
import AddSubCategories from '@/views/admin/pages/Services/addsubcategories.vue'
import AddTestimonials from '@/views/admin/pages/Content/addtestimonials.vue'
import AddUser from '@/views/admin/pages/Usermanagement/User/adduser.vue'
import AddEarnings from '@/views/admin/pages/Reports/adminearning.vue'
import AllBlog from '@/views/admin/pages/Content/Blog/allblog.vue'
import Announcements from '@/views/admin/pages/Support/announcements.vue'
import ApprovedTransferlist from '@/views/admin/pages/Finance&accounts/approved-transferlist.vue'
import Appearance from '@/views/admin/pages/settings/Websitesettings/appearance.vue'
import AuthenticationSettings from '@/views/admin/pages/settings/Websitesettings/authentication-settings.vue'
import AvailablePlugins from '@/views/admin/pages/Services/Services/available-plugins.vue'
import AwsStorage from '@/views/admin/pages/aws-storage.vue'
import BanIpAddress from '@/views/admin/pages/settings/Othersettings/banipaddress.vue'
import Banktransfer from '@/views/admin/pages/settings/Generalsettings/banktransfer.vue'
import BanktransferList from '@/views/admin/pages/Finance&accounts/banktransferlist.vue'
import BlogsCategories from '@/views/admin/pages/Content/Blog/blogs-categories.vue'
import BlogsComments from '@/views/admin/pages/Content/Blog/blogs-comments.vue'
import AdminBooking from '@/views/admin/pages/Booking/booking.vue'
import CacheSystem from '@/views/admin/pages/management/cachesystem.vue'
import CancelleBooking from '@/views/admin/pages/Booking/cancelled-booking.vue'
import CashOnDelivery from '@/views/admin/pages/Finance&accounts/cash-on-delivery.vue'
import AdminCategories from '@/views/admin/pages/Services/categories.vue'
import Changepassword from '@/views/admin/pages/change-password.vue'
import Chat from '@/views/admin/pages/Others/chat.vue'
import Cities from '@/views/admin/pages/Content/Locations/cities.vue'
import CompletedBooking from '@/views/admin/pages/Booking/completed-booking.vue'
import AdminconnectedApps from '@/views/admin/pages/settings/Generalsettings/connected-apps.vue'
import ContactMessagesView from '@/views/admin/pages/Support/contact-messages-view.vue'
import ConnectedMessages from '@/views/admin/pages/Support/connected-messages.vue'
import Countries from '@/views/admin/pages/Content/Locations/countries.vue'
import CreateMenu from '@/views/admin/pages/Services/create-menu.vue'
import Cronjob from '@/views/admin/pages/settings/Othersettings/cronjob.vue'
import Currencies from '@/views/admin/pages/settings/Financialsettings/currencies.vue'
import CurrencySettings from '@/views/admin/pages/settings/Paymentsettings/currency-settings.vue'
import DatabaseBackup from '@/views/admin/pages/settings/Othersettings/database-backup.vue'
import DeleteAccountRequest from '@/views/admin/pages/Usermanagement/delete-account-requests.vue'
import DeleteServices from '@/views/admin/pages/Services/Services/deleted-services.vue'
import AdminDeviceManagement from '@/views/admin/pages/device-management.vue'
import EditAnnouncement from '@/views/admin/pages/Support/edit-announcement.vue'
import EditBlogCategories from '@/views/admin/pages/Content/Blog/edit-blog-categories.vue'
import EditBlog from '@/views/admin/pages/Content/Blog/edit-blog.vue'
import EditCategories from '@/views/admin/pages/Services/edit-categories.vue'
import EditCity from '@/views/admin/pages/Content/Locations/edit-city.vue'
import EditCountries from '@/views/admin/pages/Content/Locations/edit-countries.vue'
import EditCoupon from '@/views/admin/pages/Marketing/edit-coupon.vue'
import EditCustomer from '@/views/admin/pages/Usermanagement/User/edit-customer.vue'
import EditEmailTemplate from '@/views/admin/pages/management/edit-email-template.vue'
import EditManagement from '@/views/admin/pages/Services/edit-managemenet.vue'
import EditOffer from '@/views/admin/pages/Marketing/edit-offer.vue'
import EditPage from '@/views/admin/pages/Content/pages/edit-page.vue'
import EditProvider from '@/views/admin/pages/Usermanagement/User/edit-provider.vue'
import EditReviewtype from '@/views/admin/pages/Services/Review/edit-reviewtype.vue'
import EditRole from '@/views/admin/pages/Usermanagement/edit-role.vue'
import EditService from '@/views/admin/pages/Services/Addservice/edit-service.vue'
import EditSmsTemplate from '@/views/admin/pages/management/edit-sms-template.vue'
import EditState from '@/views/admin/pages/Content/Locations/edit-state.vue'
import EditSubcategories from '@/views/admin/pages/Services/edit-subcategories.vue'
import EditTestimonials from '@/views/admin/pages/Content/edit-testimonials.vue'
import EditUser from '@/views/admin/pages/Usermanagement/User/edit-user.vue'
import EmailSettings from '@/views/admin/pages/settings/Systemsettings/email-settings.vue'
import EmailStorageSettings from '@/views/admin/pages/settings/Systemsettings/email-storage-settings.vue'
import EmailTemplates from '@/views/admin/pages/management/email-templates.vue'
import FacebookApi from '@/views/admin/pages/facebook-api.vue'
import AdminFaq from '@/views/admin/pages/Content/faq.vue'
import FooterSettings from '@/views/admin/pages/settings/Websitesettings/footer-settings.vue'
import GdprSettings from '@/views/admin/pages/settings/Systemsettings/gdpr-settings.vue'
import GoogleApi from '@/views/admin/pages/google-api.vue'
import HeaderSettings from '@/views/admin/pages/settings/Websitesettings/header-settings.vue'
import InactiveBlog from '@/views/admin/pages/Content/Blog/inactive-blog.vue'
import InactiveServices from '@/views/admin/pages/Services/Services/inactive-services.vue'
import AdminIndex from '@/views/admin/pages/Home/index.vue'
import InprogressBooking from '@/views/admin/pages/Booking/inprogress-booking.vue'
import Language from '@/views/admin/pages/settings/Websitesettings/language.vue'
import Localization from '@/views/admin/pages/settings/Generalsettings/localization.vue'
import Loginactivity from '@/views/admin/pages/login-activity.vue'
import MarketingCoupons from '@/views/admin/pages/Marketing/marketing-coupons.vue'
import MarketingFeatured from '@/views/admin/pages/Marketing/marketing-featured.vue'
import MarketingNewsLetter from '@/views/admin/pages/Marketing/marketing-newsletter.vue'
import MarketingService from '@/views/admin/pages/Marketing/marketing-service.vue'
import MembershipAddons from '@/views/admin/pages/Membership/membership-addons.vue'
import MembershipTransaction from '@/views/admin/pages/Reports/membership-transaction.vue'
import Membership from '@/views/admin/pages/Membership/membership.vue'
import MenuManagement from '@/views/admin/pages/Marketing/menu-management.vue'
import Nexmo from '@/views/admin/pages/nexmo.vue'
import AdminNotifications from '@/views/admin/pages/settings/Generalsettings/notifications.vue'
import PageList from '@/views/admin/pages/Content/pages/page-list.vue'
import PagesList from '@/views/admin/pages/Content/pages/pages-list.vue'
import PaymentGateways from '@/views/admin/pages/settings/Financialsettings/payment-gateways.vue'
import AdminPaymentSettings from '@/views/admin/pages/settings/Financialsettings/payment-settings.vue'
import PayoutRequest from '@/views/admin/pages/Finance&accounts/Payouts/payout-request.vue'
import PayoutSettings from '@/views/admin/pages/Finance&accounts/Payouts/payout-settings.vue'
import Paypal from '@/views/admin/pages/paypal.vue'
import pendingBlog from '@/views/admin/pages/Content/Blog/pending-blog.vue'
import PendingBooking from '@/views/admin/pages/Booking/pending-booking.vue'
import PendingServices from '@/views/admin/pages/Services/Services/pending-services.vue'
import PendingTransferlist from '@/views/admin/pages/Finance&accounts/pending-transferlist.vue'
import PhpMail from '@/views/admin/pages/php-mail.vue'
import PluginsManager from '@/views/admin/pages/Services/Services/plugins-manager.vue'
import PreferenceSettings from '@/views/admin/pages/settings/Websitesettings/preference-settings.vue'
import providerEarnings from '@/views/admin/pages/Reports/provider-earnings.vue'
import providerSettings from '@/views/admin/pages/settings/provider-settings.vue'
import RefundRequest from '@/views/admin/pages/Finance&accounts/refund-request.vue'
import RejectedTransferlist from '@/views/admin/pages/Finance&accounts/rejected-transferlist.vue'
import ReviewType from '@/views/admin/pages/Services/Review/review-type.vue'
import Review from '@/views/admin/pages/Services/Review/review.vue'
import RolePermission from '@/views/admin/pages/Usermanagement/roles.vue'
import RolesPermissions from '@/views/admin/pages/Usermanagement/permissions.vue'
import SalesTransactions from '@/views/admin/pages/Finance&accounts/sales-transactions.vue'
import Security from '@/views/admin/pages/settings/Generalsettings/security.vue'
import SeoSettings from '@/views/admin/pages/settings/Websitesettings/seo-settings.vue'
import ServiceSettings from '@/views/admin/pages/settings/service-settings.vue'
import Services from '@/views/admin/pages/Services/Services/services.vue'
import Signin from '@/views/admin/pages/signin.vue'
import SiteInformation from '@/views/admin/pages/settings/Websitesettings/site-information.vue'
import SmsSettings from '@/views/admin/pages/settings/Systemsettings/sms-settings.vue'
import SmsTemplates from '@/views/admin/pages/management/sms-templates.vue'
import Smtp from '@/views/admin/pages/smtp.vue'
import SocialAuthentication from '@/views/admin/pages/settings/Websitesettings/social-authentication.vue'
import SocialProfiles from '@/views/admin/pages/settings/Generalsettings/social-profiles.vue'
import States from '@/views/admin/pages/Content/Locations/states.vue'
import StorageSettings from '@/views/admin/pages/settings/Othersettings/storage-settings.vue'
import SubCategories from '@/views/admin/pages/Services/sub-categories.vue'
import SuccessfulTransferlist from '@/views/admin/pages/Finance&accounts/successful-transferlist.vue'
import SystemBackup from '@/views/admin/pages/settings/Othersettings/system-backup.vue'
import SystemInformation from '@/views/admin/pages/settings/Othersettings/system-information.vue'
import TaxRates from '@/views/admin/pages/settings/Financialsettings/tax-rates.vue'
import Testimonials from '@/views/admin/pages/Content/testimonials.vue'
import UserCustomers from '@/views/admin/pages/Usermanagement/User/customers.vue'
import UserProviders from '@/views/admin/pages/Usermanagement/User/providers.vue'
import UserList from '@/views/admin/pages/Usermanagement/User/users.vue'
import ViewService from '@/views/admin/pages/Services/Services/view-service.vue'
import WalletHistory from '@/views/admin/pages/Finance&accounts/wallet-history.vue'
import Wallet from '@/views/admin/pages/Finance&accounts/wallet.vue'
import WebsiteSettings from '@/views/admin/pages/Services/website-settings.vue'
import Active_Services from '@/views/admin/pages/Services/Services/active-services.vue'
import Resgister_Report from '@/views/admin/pages/Reports/register-report.vue'
import Provider_Sales from '@/views/admin/pages/Reports/provider-sales.vue'
import Provider_Wallet from '@/views/admin/pages/Reports/provider-wallet.vue'
import Admin_Customer_Wallet from '@/views/admin/pages/Reports/customer-wallet.vue'
import Refund_Report from '@/views/admin/pages/Reports/refund-report.vue'
import Service_Sales from '@/views/admin/pages/Reports/service-sales.vue'
import ContactMessages from '@/views/admin/pages/Support/contact-messages.vue'
import Appointment_Settings from '@/views/admin/pages/settings/Generalsettings/appointment-settings.vue'
import Typography_Settings from '@/views/admin/pages/settings/Websitesettings/typography-settings.vue'
import Calendar_Settings from '@/views/admin/pages/settings/Systemsettings/calendar-settings.vue'
import Edit_Management from '@/views/admin/pages/Marketing/edit-management.vue'
import Verification_Request from '@/views/admin/pages/Usermanagement/verification-request.vue'
import Forget_Password from '@/views/admin/pages/forget-password.vue'
import Signup from '@/views/admin/pages/signup.vue'




const routes = [
    {
        path: '/',
        name : 'login',
        component : Login
    },
    {
        path: '/success',
        name : 'success',
        component : Success
    },
    {
        path: '/forgot-password',
        name : 'forgot-password',
        component : ForgotPassword
    },
    {
        path: '/provider-register',
        name : 'provider-register',
        component : Provider_Register
    },
    {
        path: '/reset-password',
        name : 'reset-password',
        component : Reset_Password
    },
    {
        path: '/otp-phone',
        name : 'otp-phone',
        component : Otp_Phone
    },
    {
        path: '/otp-email',
        name : 'otp-email',
        component : Otp_Email
    },
    {
        path: '/free-trail',
        name : 'free-trail',
        component : Free_Trail
    },
    {
        path: '/register',
        name : 'register',
        component : Register
    },
    {
        path: '/coming-soon',
        name: 'coming-soon',
        component: ComingSoon
    },
    {
        path: '/maintenance',
        name: 'maintenance',
        component: Maintenance
    },
    {
        path: '/session-expired',
        name: 'session-expired',
        component: SessionExpired
    },
    {
        path: '/error-404',
        name: 'error-404',
        component: Error_404
    },
    {
        path: '/error-500',
        name: 'error-500',
        component: Error_500
    },
    {
        path: "/home",
        component: HomeIndex,
        children: [
          { path: "", redirect: "/home/index" },
          { path: "index", component: Index },
          { path: "index-2", component: IndexTwo },
          { path: "index-3", component: IndexThree },
          { path: "index-4", component: IndexFour },
          { path: "index-5", component: IndexFive },
          { path: "index-6", component: IndexSix },
          { path: "index-7", component: IndexSeven },
          { path: "index-8", component: IndexEight },
          { path: "index-9", component: IndexNine },
          { path: "index-10", component: IndexTen },
        ],
    },
    {
        path: "/service",
        component: ServiceIndex,
        children: [
          { path: "", redirect: "/service/services-grid" },
          { path: "services-grid", component: Services_Grid },
          { path: "services-list", component: Services_List },          
          { path: "search", component: Services_Search },          
          { path: "create-service", component: Create_Service },
          { path: "service-request", component: ServiceRequest },
        ],
    },
    {
        path: "/details",
        component: DetailIndex,
        children: [
            { path: "", redirect: "/details/service-details" },
            { path: "service-details", component: Services_Details },
            { path: "service-details-two", component: Services_Details2 },
        ]
    },
    {
        path: "/service-provider",
        component: ServiceProvider,
        children: [
            { path: "", redirect: "/service-provider/providers" },
            { path: "providers", component: Services_Providers },
            { path: "provider-details", component: Provider_Details },
        ]
    },
    {
        path: "/service-categories",
        component: ServiceCategories,
        children: [
            { path: "", redirect: "/service-categories/categories" },
            { path: "categories", component: Services_Categories },
            { path: "categories-2", component: Services_Categories_2 },
        ]
    },
    {
        path: "/customer",
        component: CustomerIndex,
        children: [
          { path: "", redirect: "/customer/user-dashboard" },
          { path: "user-dashboard", component: User_Dashboard },
          { path: "user-booking-list", component: User_Booking_List },
          { path: "user-bookings-calendar", component: User_Booking_Calendar },
          { path: "favourites", component: Favourites },
          { path: "customer-wallet", component: Customer_Wallet },
          { path: "customer-reviews", component: Customer_Reviews },
          { path: "user-chat", component: User_Chat },          
        ],
    },
    {
        path: "/customer-settings",
        component: CustomerSettings,
        children: [
            { path: "", redirect: "/customer-settings/account-settings" },
            { path: "account-settings", component: Account_Settings },
            { path: "security-settings", component: Security_Settings },
            { path: "notification-settings", component: Notification_Settings },
            { path: "connected-apps", component: Connected_Apps },
            { path: "device-managment", component: Device_Managment },
            { path: "login-activity", component: Login_Activity },
        ]
    },
    {
        path: '/booking',
        component: FrontBooking,
        children: [
          { path: '', redirect: '/booking/booking' },
          { path: "booking", component: PagesBooking },
          { path: "user-booking", component: User_Booking },
          { path: "booking-payment", component: Booking_Payment },
          { path: "booking-success", component: Booking_Success },
          { path: "booking-details", component: Booking_Details },
          { path: "invoice", component: Invoice },
        ]
    },
    {
        path: '/pages',
        component: Pages,
        children: [
          { path: '', redirect: '/pages/about-us' },
          { path: "about-us", component: AboutUs },
          { path: "terms-condition", component: TermsConditions },
          { path: "faq", component: Faq },
          { path: "pricing", component: Pricing },
          { path: "privacy-policy", component: PrivacyPolicy },
          { path: "how-it-works", component: HowItWorks },
          { path: "categories", component: Categories },
          { path: "contact-us", component: ContactUs },
          { path: "installer", component: Installer },
          { path: "notification", component: NotificationPage },
          
        ]
    },
    {
        path: '/blogs',
        component: Blogs,
        children: [
          { path: '', redirect: '/blogs/blog-grid' },
          { path: "blog-grid", component: Blog_Grid },
          { path: "blog-list", component: Blog_List },
          { path: "blog-details", component: Blog_Details },
        ]
    },
    {
        path: '/provider-settings',
        component: Provider_Settings,
        children: [
          { path: '', redirect: '/provider-settings/provider-appointment-settings' },
          { path: "provider-appointment-settings", component: Provider_Appointment_Settings },
          { path: "provider-accounts-settings", component: Provider_Accounts_Settings },
          { path: "provider-social-profile", component: Provider_Social_Profile },
          { path: "provider-security-settings", component: Provider_Security_Settings },
          { path: "provider-plan", component: Provider_Plan },
          { path: "payment-settings", component: Payment_Settings },
          { path: "provider-notifcations", component: Provider_Notifcations },
          { path: "provider-connected-apps", component: Provider_Connected_Apps },
          { path: "provider-login-activity", component: Provider_Login_Activity },
          { path: "provider-device-management", component: Provider_Device_Management },
          { path: "verification", component: Verification },
        ]
    },
    {
        path: '/provider',
        component: Provider,
        children: [
          { path: '', redirect: '/provider/provider-dashboard' },
          { path: "provider-dashboard", component: Provider_Dashboard },
          { path: "provider-services", component: Provider_Services },
          { path: "provider-booking", component: Provider_Booking },
          { path: "provider-booking-calendar", component: Provider_Booking_Calendar },
          { path: "staff-list", component: Staff_List },
          { path: "staff-grid", component: Staff_Grid },
          { path: "staff-details", component: Staff_Details },
          { path: "customer-list", component: Customer_List },
          { path: "customer-grid", component: Customer_Grid },
          { path: "customer-details", component: Customer_Details },
          { path: "provider-payout", component: Provider_Payout },
          { path: "provider-holiday", component: Provider_Holiday },
          { path: "provider-coupons", component: Provider_Coupons },
          { path: "provider-offers", component: Provider_Offers },
          { path: "provider-reviews", component: Provider_Reviews },
          { path: "provider-chat", component: Provider_Chat },
          { path: "provider-earnings", component: Provider_Earnings },
          { path: "provider-enquiry", component: Provider_Enquiry },
          { path: "provider-leave-history", component: Provider_Leave_History },
          { path: "provider-transaction", component: Provider_Transaction },
          { path: "provider-service-list", component: Provider_Service_List },
        ]
    },




/**************** Admin  *************/

{
    path: '/admin/abuse-reports',
    name: '/admin/abuse-reports',
    component: abusereports
},
{
    path: '/admin/account-settings',
    name: '/admin/account-settings',
    component: Accountsettings
},
{
    path: '/admin/add-announcement',
    name: '/admin/add-announcement',
    component: Addannouncement
},
{
    path: '/admin/add-blog-categories',
    name: '/admin/add-blog-categories',
    component: AddBlogcategories
},
{
    path: '/admin/add-blog',
    name: '/admin/add-blog',
    component: AddBlog
},
{
    path: '/admin/add-categories',
    name: '/admin/add-categories',
    component: AddCategories
},
{
    path: '/admin/add-city',
    name: '/admin/add-city',
    component: AddCity
},
{
    path: '/admin/add-countries',
    name: '/admin/add-countries',
    component: AddCountries
},
{
    path: '/admin/add-customer',
    name: '/admin/add-customer',
    component: AddCustomer
},
{
    path: '/admin/add-membership',
    name: '/admin/add-membership',
    component: AddMembership
},
{
    path: '/admin/add-page',
    name: '/admin/add-page',
    component: AddPage
},
{
    path: '/admin/add-payout',
    name: '/admin/add-payout',
    component: AddPayout
},
{
    path: '/admin/add-provider',
    name: '/admin/add-provider',
    component: AddProvider
},
{
    path: '/admin/add-reviewtype',
    name: '/admin/add-reviewtype',
    component: AddReviewtype
},
{
    path: '/admin/add-role',
    name: '/admin/add-role',
    component: AddRole
},
{
    path: '/admin/add-service',
    name: '/admin/add-service',
    component: AddService
},
{
    path: '/admin/add-state',
    name: '/admin/add-state',
    component: AddState
},
{
    path: '/admin/add-subcategories',
    name: '/admin/add-subcategories',
    component: AddSubCategories
},
{
    path: '/admin/add-testimonials',
    name: '/admin/add-testimonials',
    component: AddTestimonials
},
{
    path: '/admin/add-user',
    name: '/admin/add-user',
    component: AddUser
},
{
    path: '/admin/admin-earnings',
    name: '/admin/admin-earnings',
    component: AddEarnings
},
{
    path: '/admin/all-blog',
    name: '/admin/all-blog',
    component: AllBlog
},
{
    path: '/admin/announcements',
    name: '/admin/announcements',
    component: Announcements
},
{
    path: '/admin/approved-transferlist',
    name: '/admin/approved-transferlist',
    component: ApprovedTransferlist
},
{
    path: '/admin/appearance',
    name: '/admin/appearance',
    component: Appearance
},
{
    path: '/admin/authentication-settings',
    name: '/admin/authentication-settings',
    component: AuthenticationSettings
},
{
    path: '/admin/available-plugins',
    name: '/admin/available-plugins',
    component: AvailablePlugins
},
{
    path: '/admin/aws-storage',
    name: '/admin/aws-storage',
    component: AwsStorage
},
{
    path: '/admin/ban-ip-address',
    name: '/admin/ban-ip-address',
    component: BanIpAddress
},
{
    path: '/admin/banktransfer',
    name: '/admin/banktransfer',
    component: Banktransfer
},
{
    path: '/admin/banktransferlist',
    name: '/admin/banktransferlist',
    component: BanktransferList
},
{
    path: '/admin/blogs-categories',
    name: '/admin/blogs-categories',
    component: BlogsCategories
},
{
    path: '/admin/blogs-comments',
    name: '/admin/blogs-comments',
    component: BlogsComments
},
{
    path: '/admin/booking',
    name: '/admin/adminbooking',
    component: AdminBooking
},
{
    path: '/admin/cachesystem',
    name: '/admin/cachesystem',
    component: CacheSystem
},
{
    path: '/admin/cancelled-booking',
    name: '/admin/cancelled-booking',
    component: CancelleBooking
},
{
    path: '/admin/cash-on-delivery',
    name: '/admin/cash-on-delivery',
    component: CashOnDelivery
},
{
    path: '/admin/categories',
    name: '/admin/admincategories',
    component: AdminCategories
},
{
    path: '/admin/change-password',
    name: '/admin/adminchange-password',
    component: Changepassword
},
{
    path: '/admin/chat',
    name: '/admin/chat',
    component: Chat
},
{
    path: '/admin/cities',
    name: '/admin/cities',
    component: Cities
},
{
    path: '/admin/completed-booking',
    name: '/admin/completed-booking',
    component: CompletedBooking
},
{
    path: '/admin/connected-apps',
    name: '/admin/adminconnected-apps',
    component: AdminconnectedApps
},
{
    path: '/admin/contact-messages-view',
    name: '/admin/contact-messages-view',
    component: ContactMessagesView
},
{
    path: '/admin/connected-messages',
    name: '/admin/connected-messages',
    component: ConnectedMessages
},
{
    path: '/admin/countries',
    name: '/admin/countries',
    component: Countries
},
{
    path: '/admin/create-menu',
    name: '/admin/admincreate-menu',
    component: CreateMenu
},
{
    path: '/admin/cronjob',
    name: '/admin/cronjob',
    component: Cronjob
},
{
    path: '/admin/currencies',
    name: '/admin/currencies',
    component: Currencies
},
{
    path: '/admin/currency-settings',
    name: '/admin/currency-settings',
    component: CurrencySettings
},
{
    path: '/admin/database-backup',
    name: '/admin/database-backup',
    component: DatabaseBackup
},
{
    path: '/admin/delete-account-requests',
    name: '/admin/delete-account-requests',
    component: DeleteAccountRequest
},
{
    path: '/admin/deleted-services',
    name: '/admin/deleted-services',
    component: DeleteServices
},
{
    path: '/admin/device-management',
    name: '/admin/admindevice-management',
    component: AdminDeviceManagement
},
{
    path: '/admin/edit-announcement',
    name: '/admin/edit-announcement',
    component: EditAnnouncement
},
{
    path: '/admin/edit-blog-categories',
    name: '/admin/edit-blog-categories',
    component: EditBlogCategories
},
{
    path: '/admin/edit-blog',
    name: '/admin/edit-blog',
    component: EditBlog
},
{
    path: '/admin/edit-categories',
    name: '/admin/edit-categories',
    component: EditCategories
},
{
    path: '/admin/edit-city',
    name: '/admin/edit-city',
    component: EditCity
},
{
    path: '/admin/edit-countries',
    name: '/admin/edit-countries',
    component: EditCountries
},
{
    path: '/admin/edit-coupon',
    name: '/admin/edit-coupon',
    component: EditCoupon
},
{
    path: '/admin/edit-customer',
    name: '/admin/edit-customer',
    component: EditCustomer
},
{
    path: '/admin/edit-email-template',
    name: '/admin/edit-email-template',
    component: EditEmailTemplate
},
{
    path: '/admin/edit-management',
    name: '/admin/edit-management',
    component: EditManagement
},
{
    path: '/admin/edit-offer',
    name: '/admin/edit-offer',
    component: EditOffer
},
{
    path: '/admin/edit-page',
    name: '/admin/edit-page',
    component: EditPage
},
{
    path: '/admin/edit-provider',
    name: '/admin/edit-provider',
    component: EditProvider
},
{
    path: '/admin/edit-reviewtype',
    name: '/admin/edit-reviewtype',
    component: EditReviewtype
},
{
    path: '/admin/edit-role',
    name: '/admin/edit-role',
    component: EditRole
},
{
    path: '/admin/edit-service',
    name: '/admin/edit-service',
    component: EditService
},
{
    path: '/admin/edit-sms-template',
    name: '/admin/edit-sms-template',
    component: EditSmsTemplate
},
{
    path: '/admin/edit-state',
    name: '/admin/edit-state',
    component: EditState
},
{
    path: '/admin/edit-subcategories',
    name: 'edit-subcategories',
    component: EditSubcategories
},
{
    path: '/admin/edit-testimonials',
    name: '/admin/edit-testimonials',
    component: EditTestimonials
},
{
    path: '/admin/edit-user',
    name: '/admin/edit-user',
    component: EditUser
},
{
    path: '/admin/email-settings',
    name: '/admin/email-settings',
    component: EmailSettings
},
{
    path: '/admin/email-storage-settings',
    name: '/admin/email-storage-settings',
    component: EmailStorageSettings
},
{
    path: '/admin/email-templates',
    name: '/admin/email-templates',
    component: EmailTemplates
},
{
    path: '/admin/facebook-api',
    name: '/admin/facebook-api',
    component: FacebookApi
},
{
    path: '/admin/faq',
    name: '/admin/adminfaq',
    component: AdminFaq
},
{
    path: '/admin/footer-settings',
    name: '/admin/footer-settings',
    component: FooterSettings
},
{
    path: '/admin/gdpr-settings',
    name: '/admin/gdpr-settings',
    component: GdprSettings
},
{
    path: '/admin/google-api',
    name: '/admin/google-api',
    component: GoogleApi
},
{
    path: '/admin/header-settings',
    name: '/admin/header-settings',
    component: HeaderSettings
},
{
    path: '/admin/inactive-blog',
    name: '/admin/inactive-blog',
    component: InactiveBlog
},
{
    path: '/admin/inactive-services',
    name: '/admin/inactive-services',
    component: InactiveServices
},
{
    path: '/admin/index',
    name: '/admin/adminindex',
    component: AdminIndex
},
{
    path: '/admin/inprogress-booking',
    name: '/admin/inprogress-booking',
    component: InprogressBooking
},
{
    path: '/admin/language',
    name: '/admin/language',
    component: Language
},
{
    path: '/admin/localization',
    name: '/admin/localization',
    component: Localization
},
{
    path: '/admin/login-activity',
    name: '/admin/adminlogin-activity',
    component: Loginactivity
},
{
    path: '/admin/coupons',
    name: '/admin/coupons',
    component: MarketingCoupons
},
{
    path: '/admin/featured-services',
    name: '/admin/featured-services',
    component: MarketingFeatured
},
{
    path: '/admin/email-newsletter',
    name: '/admin/email-newsletter',
    component: MarketingNewsLetter
},
{
    path: '/admin/offers',
    name: '/admin/offers',
    component: MarketingService
},
{
    path: '/admin/membership-addons',
    name: '/admin/membership-addons',
    component: MembershipAddons
},
{
    path: '/admin/membership-transaction',
    name: '/admin/membership-transaction',
    component: MembershipTransaction
},
{
    path: '/admin/membership',
    name: '/admin/membership',
    component: Membership
},
{
    path: '/admin/menu-management',
    name: '/admin/menu-management',
    component: MenuManagement
},
{
    path: '/admin/nexmo',
    name: '/admin/nexmo',
    component: Nexmo
},
{
    path: '/admin/notifications',
    name: '/admin/adminnotifications',
    component: AdminNotifications
},
{
    path: '/admin/page-list',
    name: '/admin/page-list',
    component: PageList
},
{
    path: '/admin/pages-list',
    name: '/admin/pages-list',
    component: PagesList
},
{
    path: '/admin/payment-gateways',
    name: '/admin/payment-gateways',
    component: PaymentGateways
},
{
    path: '/admin/payment-settings',
    name: '/admin/adminpayment-settings',
    component: AdminPaymentSettings
},
{
    path: '/admin/payout-request',
    name: '/admin/payout-request',
    component: PayoutRequest
},
{
    path: '/admin/payout-settings',
    name: '/admin/payout-settings',
    component: PayoutSettings
},
{
    path: '/admin/paypal',
    name: '/admin/paypal',
    component: Paypal
},
{
    path: '/admin/pending-blog',
    name: '/admin/pending-blog',
    component: pendingBlog
},
{
    path: '/admin/pending-booking',
    name: '/admin/pending-booking',
    component: PendingBooking
},
{
    path: '/admin/pending-services',
    name: '/admin/pending-services',
    component: PendingServices
},
{
    path: '/admin/pending-transferlist',
    name: '/admin/pending-transferlist',
    component: PendingTransferlist
},
{
    path: '/admin/php-mail',
    name: '/admin/php-mail',
    component: PhpMail
},
{
    path: '/admin/plugins-manager',
    name: '/admin/plugins-manager',
    component: PluginsManager
},
{
    path: '/admin/preference-settings',
    name: '/admin/preference-settings',
    component: PreferenceSettings
},
{
    path: '/admin/provider-earnings',
    name: '/admin/adminprovider-earnings',
    component: providerEarnings
},
{
    path: '/admin/provider-settings',
    name: '/admin/adminprovider-settings',
    component: providerSettings
},
{
    path: '/admin/refund-request',
    name: '/admin/refund-request',
    component: RefundRequest
},
{
    path: '/admin/rejected-transferlist',
    name: '/admin/rejected-transferlist',
    component: RejectedTransferlist
},
{
    path: '/admin/review-type',
    name: '/admin/review-type',
    component: ReviewType
},
{
    path: '/admin/review',
    name: '/admin/review',
    component: Review
},
{
    path: '/admin/roles',
    name: '/admin/roles',
    component: RolePermission
},
{
    path: '/admin/permissions',
    name: '/admin/permissions',
    component: RolesPermissions
},
{
    path: '/admin/sales-transactions',
    name: '/admin/sales-transactions',
    component: SalesTransactions
},
{
    path: '/admin/security',
    name: '/admin/security',
    component: Security
},
{
    path: '/admin/seo-settings',
    name: '/admin/seo-settings',
    component: SeoSettings
},
{
    path: '/admin/service-settings',
    name: '/admin/service-settings',
    component: ServiceSettings
},
{
    path: '/admin/services',
    name: '/admin/services',
    component: Services
},
{
    path: '/admin/signin',
    name: '/admin/signin',
    component: Signin
},
{
    path: '/admin/site-information',
    name: '/admin/site-information',
    component: SiteInformation
},
{
    path: '/admin/sms-settings',
    name: '/admin/sms-settings',
    component: SmsSettings
},
{
    path: '/admin/sms-templates',
    name: '/admin/sms-templates',
    component: SmsTemplates
},
{
    path: '/admin/smtp',
    name: '/admin/smtp',
    component: Smtp
},
{
    path: '/admin/social-authentication',
    name: '/admin/social-authentication',
    component: SocialAuthentication
},
{
    path: '/admin/social-profiles',
    name: '/admin/social-profiles',
    component: SocialProfiles
},
{
    path: '/admin/states',
    name: '/admin/states',
    component: States
},
{
    path: '/admin/storage-settings',
    name: '/admin/storage-settings',
    component: StorageSettings
},
{
    path: '/admin/sub-categories',
    name: '/admin/sub-categories',
    component: SubCategories
},
{
    path: '/admin/successful-transferlist',
    name: '/admin/successful-transferlist',
    component: SuccessfulTransferlist
},
{
    path: '/admin/system-backup',
    name: '/admin/system-backup',
    component: SystemBackup
},
{
    path: '/admin/system-information',
    name: '/admin/system-information',
    component: SystemInformation
},
{
    path: '/admin/tax-rates',
    name: '/admin/tax-rates',
    component: TaxRates
},
{
    path: '/admin/testimonials',
    name: '/admin/testimonials',
    component: Testimonials
},
{
    path: '/admin/customers',
    name: '/admin/customers',
    component: UserCustomers
},
{
    path: '/admin/providers',
    name: '/admin/providers',
    component: UserProviders
},
{
    path: '/admin/users',
    name: '/admin/users',
    component: UserList
},
{
    path: '/admin/view-service',
    name: '/admin/view-service',
    component: ViewService
},
{
    path: '/admin/wallet-history',
    name: '/admin/wallet-history',
    component: WalletHistory
},
{
    path: '/admin/wallet',
    name: '/admin/wallet',
    component: Wallet
},
{
    path: '/admin/website-settings',
    name: '/admin/website-settings',
    component: WebsiteSettings
},
{
    path: '/admin/active-services',
    name: '/admin/active-services',
    component: Active_Services
},

{
    path: '/admin/register-report',
    name: '/admin/register-report',
    component: Resgister_Report
},
{
    path: '/admin/provider-sales',
    name: '/admin/provider-sales',
    component: Provider_Sales
},
{
    path: '/admin/provider-wallet',
    name: '/admin/provider-wallet',
    component: Provider_Wallet
},
{
    path: '/admin/customer-wallet',
    name: '/admin/customer-wallet',
    component: Admin_Customer_Wallet
},
{
    path: '/admin/refund-report',
    name: '/admin/refund-report',
    component: Refund_Report
},
{
    path: '/admin/service-sales',
    name: '/admin/service-sales',
    component: Service_Sales
},
{
    path: '/admin/contact-messages',
    name: '/admin/contact-messages',
    component: ContactMessages
},
{
    path: '/admin/appointment-settings',
    name: '/admin/appointment-settings',
    component: Appointment_Settings
},
{
    path: '/admin/typography-settings',
    name: '/admin/typography-settings',
    component: Typography_Settings
},
{
    path: '/admin/calendar-settings',
    name: '/admin/calendar-settings',
    component: Calendar_Settings
},
{
    path: '/admin/edit-management',
    name: '/admin/edit-management',
    component: Edit_Management
},
{
    path: '/admin/verification-request',
    name: '/admin/verification-request',
    component: Verification_Request
},
{
    path: '/admin/forgot-password',
    name: '/admin/forgot-password',
    component: Forget_Password
},
{
    path: '/admin/signup',
    name: '/admin/signup',
    component: Signup
},

]


export const router = createRouter({
    history: createWebHistory('/vue/template/'),
    linkActiveClass: 'active',
    routes,
}); 

router.beforeEach((to, from, next) => {
// Scroll to the top of the page
window.scrollTo({ top: 0, behavior: 'smooth' });
// Continue with the navigation
next();
});
    